import { IconDefinition } from "./types";

/**
 * @deprecated Use `arrowRight` instead. This icon will be removed in a future version.
 */
const rightArrow: IconDefinition = {
  iconName: "right-arrow",
  width: 576,
  height: 512,
  svgPathData:
    "M537.4 273l17-17-17-17-168-168-17-17-33.9 33.9 17 17 127 127-430.1 0 0 48 430.1 0-127 127-17 17 33.9 33.9 17-17 168-168z",
  iconType: "fill",
  unicode: 0xf061,
};

export { rightArrow };
